exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".warning{position:fixed;width:100%;z-index:999999}#app.maintenance{padding-top:36px}#app.maintenance .sidebar-container{padding-top:36px}", ""]);

// exports
